import { render } from "./ShopViolations.vue?vue&type=template&id=6b167f1f&scoped=true"
import script from "./ShopViolations.vue?vue&type=script&lang=js"
export * from "./ShopViolations.vue?vue&type=script&lang=js"

import "./ShopViolations.vue?vue&type=style&index=0&id=6b167f1f&lang=scss&scoped=true"
import "./ShopViolations.vue?vue&type=style&index=1&id=6b167f1f&lang=scss"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b167f1f"]])

export default __exports__